module.exports = __webpack_public_path__ + "static/IT-recruiter-290e95ea8a181170aa8aaf2e3917c97d.svg";